export default __webpack_public_path__ + "static/media/Dragon-e-Baby-Gone.648e0c68.jpg";